import '../../assets/index44.css';var X = Object.defineProperty, tt = Object.defineProperties;
var et = Object.getOwnPropertyDescriptors;
var $ = Object.getOwnPropertySymbols;
var G = Object.prototype.hasOwnProperty, H = Object.prototype.propertyIsEnumerable;
var F = (e, a, t) => a in e ? X(e, a, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[a] = t, r = (e, a) => {
  for (var t in a || (a = {}))
    G.call(a, t) && F(e, t, a[t]);
  if ($)
    for (var t of $(a))
      H.call(a, t) && F(e, t, a[t]);
  return e;
}, m = (e, a) => tt(e, et(a));
var h = (e, a) => {
  var t = {};
  for (var o in e)
    G.call(e, o) && a.indexOf(o) < 0 && (t[o] = e[o]);
  if (e != null && $)
    for (var o of $(e))
      a.indexOf(o) < 0 && H.call(e, o) && (t[o] = e[o]);
  return t;
};
import { jsx as f, jsxs as at } from "react/jsx-runtime";
import "react";
import { e as ot } from "../../get-size-Bc1Pz5yf.js";
import { c as st } from "../../create-vars-resolver-Bzbn9G-G.js";
import { f as D, u as M, B as V, b as nt, h as q } from "../../factory-ueRxoNOV.js";
import { g as rt } from "../../get-contrast-color-SC35uhiM.js";
import { g as lt } from "../../get-auto-contrast-value-BGSSZ1GD.js";
import { u as it } from "../../use-styles-DToiHEa6.js";
import { c as ct } from "../../create-safe-context-DqDyoPVE.js";
import { c as dt } from "../../create-scoped-keydown-handler-7Vh4D_UG.js";
import { u as bt } from "../../DirectionProvider-CT8S13Cp.js";
import { U as mt } from "../../UnstyledButton-D9OCzDhz.js";
import { u as ut } from "../../use-id-D2tGiO9x.js";
import { u as pt } from "../../use-uncontrolled-BT_j5D2R.js";
function Y(e, a) {
  return (t) => {
    if (typeof t != "string" || t.trim().length === 0)
      throw new Error(a);
    return `${e}-${t}`;
  };
}
const [vt, U] = ct(
  "Tabs component was not found in the tree"
);
var w = { root: "m_89d60db1", "list--default": "m_576c9d4", list: "m_89d33d6d", panel: "m_b0c91715", tab: "m_4ec4dce6", tabSection: "m_fc420b1f", "tab--default": "m_539e827b", "list--outline": "m_6772fbd5", "tab--outline": "m_b59ab47c", "tab--pills": "m_c3381914" };
const Tt = {}, z = D((e, a) => {
  const t = M("TabsList", Tt, e), b = t, { children: o, className: p, grow: c, justify: i, classNames: l, styles: d, style: _, mod: v } = b, T = h(b, ["children", "className", "grow", "justify", "classNames", "styles", "style", "mod"]), n = U();
  return /* @__PURE__ */ f(
    V,
    m(r(r({}, T), n.getStyles("list", {
      className: p,
      style: _,
      classNames: l,
      styles: d,
      props: t,
      variant: n.variant
    })), {
      ref: a,
      role: "tablist",
      variant: n.variant,
      mod: [
        {
          grow: c,
          orientation: n.orientation,
          placement: n.orientation === "vertical" && n.placement,
          inverted: n.inverted
        },
        v
      ],
      "aria-orientation": n.orientation,
      __vars: { "--tabs-justify": i },
      children: o
    })
  );
});
z.classes = w;
z.displayName = "@mantine/core/TabsList";
const ft = {}, A = D((e, a) => {
  const t = M("TabsPanel", ft, e), y = t, { children: o, className: p, value: c, classNames: i, styles: l, style: d, mod: _, keepMounted: v } = y, T = h(y, ["children", "className", "value", "classNames", "styles", "style", "mod", "keepMounted"]), n = U(), b = n.value === c, g = n.keepMounted || v || b ? o : null;
  return /* @__PURE__ */ f(
    V,
    m(r(r({}, T), n.getStyles("panel", {
      className: p,
      classNames: i,
      styles: l,
      style: [d, b ? void 0 : { display: "none" }],
      props: t
    })), {
      ref: a,
      mod: [{ orientation: n.orientation }, _],
      role: "tabpanel",
      id: n.getPanelId(c),
      "aria-labelledby": n.getTabId(c),
      children: g
    })
  );
});
A.classes = w;
A.displayName = "@mantine/core/TabsPanel";
const _t = {}, B = D((e, a) => {
  const t = M("TabsTab", _t, e), L = t, {
    className: o,
    children: p,
    rightSection: c,
    leftSection: i,
    value: l,
    onClick: d,
    onKeyDown: _,
    disabled: v,
    color: T,
    style: n,
    classNames: b,
    styles: g,
    vars: y,
    mod: N,
    tabIndex: x
  } = L, R = h(L, [
    "className",
    "children",
    "rightSection",
    "leftSection",
    "value",
    "onClick",
    "onKeyDown",
    "disabled",
    "color",
    "style",
    "classNames",
    "styles",
    "vars",
    "mod",
    "tabIndex"
  ]), K = nt(), { dir: C } = bt(), s = U(), S = l === s.value, j = (k) => {
    s.onChange(s.allowTabDeactivation && l === s.value ? null : l), d == null || d(k);
  }, P = { classNames: b, styles: g, props: t };
  return /* @__PURE__ */ at(
    mt,
    m(r(r({}, R), s.getStyles("tab", r({ className: o, style: n, variant: s.variant }, P))), {
      disabled: v,
      unstyled: s.unstyled,
      variant: s.variant,
      mod: [
        {
          active: S,
          disabled: v,
          orientation: s.orientation,
          inverted: s.inverted,
          placement: s.orientation === "vertical" && s.placement
        },
        N
      ],
      ref: a,
      role: "tab",
      id: s.getTabId(l),
      "aria-selected": S,
      tabIndex: x !== void 0 ? x : S || s.value === null ? 0 : -1,
      "aria-controls": s.getPanelId(l),
      onClick: j,
      __vars: { "--tabs-color": T ? q(T, K) : void 0 },
      onKeyDown: dt({
        siblingSelector: '[role="tab"]',
        parentSelector: '[role="tablist"]',
        activateOnFocus: s.activateTabWithKeyboard,
        loop: s.loop,
        orientation: s.orientation || "horizontal",
        dir: C,
        onKeyDown: _
      }),
      children: [
        i && /* @__PURE__ */ f("span", m(r({}, s.getStyles("tabSection", P)), { "data-position": "left", children: i })),
        p && /* @__PURE__ */ f("span", m(r({}, s.getStyles("tabLabel", P)), { children: p })),
        c && /* @__PURE__ */ f("span", m(r({}, s.getStyles("tabSection", P)), { "data-position": "right", children: c }))
      ]
    })
  );
});
B.classes = w;
B.displayName = "@mantine/core/TabsTab";
const Z = "Tabs.Tab or Tabs.Panel component was rendered with invalid value or without value", yt = {
  keepMounted: !0,
  orientation: "horizontal",
  loop: !0,
  activateTabWithKeyboard: !0,
  allowTabDeactivation: !1,
  unstyled: !1,
  inverted: !1,
  variant: "default",
  placement: "left"
}, ht = st((e, { radius: a, color: t, autoContrast: o }) => ({
  root: {
    "--tabs-radius": ot(a),
    "--tabs-color": q(t, e),
    "--tabs-text-color": lt(o, e) ? rt({ color: t, theme: e, autoContrast: o }) : void 0
  }
})), u = D((e, a) => {
  const t = M("Tabs", yt, e), O = t, {
    defaultValue: o,
    value: p,
    onChange: c,
    orientation: i,
    children: l,
    loop: d,
    id: _,
    activateTabWithKeyboard: v,
    allowTabDeactivation: T,
    variant: n,
    color: b,
    radius: g,
    inverted: y,
    placement: N,
    keepMounted: x,
    classNames: R,
    styles: K,
    unstyled: C,
    className: s,
    style: S,
    vars: j,
    autoContrast: P,
    mod: L
  } = O, k = h(O, [
    "defaultValue",
    "value",
    "onChange",
    "orientation",
    "children",
    "loop",
    "id",
    "activateTabWithKeyboard",
    "allowTabDeactivation",
    "variant",
    "color",
    "radius",
    "inverted",
    "placement",
    "keepMounted",
    "classNames",
    "styles",
    "unstyled",
    "className",
    "style",
    "vars",
    "autoContrast",
    "mod"
  ]), I = ut(_), [J, Q] = pt({
    value: p,
    defaultValue: o,
    finalValue: null,
    onChange: c
  }), W = it({
    name: "Tabs",
    props: t,
    classes: w,
    className: s,
    style: S,
    classNames: R,
    styles: K,
    unstyled: C,
    vars: j,
    varsResolver: ht
  });
  return /* @__PURE__ */ f(
    vt,
    {
      value: {
        placement: N,
        value: J,
        orientation: i,
        id: I,
        loop: d,
        activateTabWithKeyboard: v,
        getTabId: Y(`${I}-tab`, Z),
        getPanelId: Y(`${I}-panel`, Z),
        onChange: Q,
        allowTabDeactivation: T,
        variant: n,
        color: b,
        radius: g,
        inverted: y,
        keepMounted: x,
        unstyled: C,
        getStyles: W
      },
      children: /* @__PURE__ */ f(
        V,
        m(r(r({
          ref: a,
          id: I,
          variant: n,
          mod: [
            {
              orientation: i,
              inverted: i === "horizontal" && y,
              placement: i === "vertical" && N
            },
            L
          ]
        }, W("root")), k), {
          children: l
        })
      )
    }
  );
});
u.classes = w;
u.displayName = "@mantine/core/Tabs";
u.Tab = B;
u.Panel = A;
u.List = z;
const gt = "Tabs-module__root___TDadZ", St = "Tabs-module__list___niDj9", Pt = "Tabs-module__tab___YmRhr", wt = "Tabs-module__tabLabel___0iG0C", Nt = "Tabs-module__panel___hM0kM", xt = {
  root: gt,
  list: St,
  tab: Pt,
  tabLabel: wt,
  panel: Nt
}, E = (t) => {
  var o = t, { children: e } = o, a = h(o, ["children"]);
  return /* @__PURE__ */ f(
    u,
    m(r({
      classNames: xt
    }, a), {
      children: e
    })
  );
};
E.List = u.List;
E.Tab = u.Tab;
E.Panel = u.Panel;
export {
  E as Tabs
};
